import { ChartComponent } from '..'
import { PatternType } from './bars'
import { Limits } from './limits'

export type Rect = {
  x: number
  y: number
  width: number
  height: number
  fill: string
  label?: string
  pattern?: PatternType
  gradient?: boolean
  orientation?: 'vertical' | 'horizontal'
}

export function createRect(
  { x, y, width, height, fill, label, pattern, gradient, orientation = 'vertical' }: Rect,
  limits: Limits
): ChartComponent<'line'> {
  return {
    type: 'line',
    label: label,
    fill: fill,
    pattern: pattern,
    xLimits: limits.x,
    yLimits: limits.y,
    gradient: gradient
      ? {
          fill: {
            type: 'INTERPOLATE',
            orientation,
            cutoffs: [
              { value: limits.y[0], color: fill, opacity: 0.25 },
              { value: limits.y[1], color: fill, opacity: 1 }
            ]
          }
        }
      : undefined,
    values: [
      [x, y],
      [x + width, y],
      [x + width, y + height],
      [x, y + height],
      [x, y]
    ]
  }
}
